import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { IOrdersData } from '../../../interfaces/service.response';


@Component({
    selector: 'cu-download-link-cell-renderer',
    template: `
    
      <i title="Change order" [ngClass]="{'d-none':!showEdit}" class="fa {{params.editicon}} green-fa" (click)="onClickChange()" aria-hidden="true"></i>&nbsp;
      <i [title]="closeable? 'Close order': 'Cancel order'" [ngClass]="{'d-none': !showDelete}" class="fa {{params.icon}} _red-fa" (click)="onClick()" aria-hidden="true"></i>
    `
  })
  export class OrderCellRendererComponent {
  
      params:any;
  
      constructor() {
      }
  
      agInit(params:any): void { 
          this.params = params;

          let rowOrderParams:IOrdersData = <IOrdersData>this.params.data;

          this.closeable = (rowOrderParams.MenuRequests.indexOf("CloseReq")>-1)?true:false;
          this.showDelete = true;//(rowOrderParams.MenuRequests.indexOf("CloseReq")>-1)?true:false;

         this.showEdit = false; 
     }
  
     private _showDelete:boolean=true;
     private _showEdit:boolean=true;


     closeable: boolean = false;

     set showDelete(v:boolean)
     {
         this._showDelete=v;
     }
     
     get showDelete():boolean
     {
         return this._showDelete;
     }

     set showEdit(v:boolean)
     {
         this._showEdit=v;
     }
     
     get showEdit():boolean
     {
         return this._showEdit;
     }


     onClick(): void {
         this.params.action(this.params);
     }

     onClickChange(): void {
        this.params.edit(this.params);
    }
  }
  
  export type CellAction = (params:any) => void;